import { apiGet } from "../standardApi";

export const apiMedadomURL = async () => {
    return apiGet('/Affiliates/MedadomUrl');
};
